import feathers from '@feathersjs/feathers'
import rest from '@feathersjs/rest-client'
import authentication from '@feathersjs/authentication-client';

export const apiHost = 'https://showroom.preyai.site'
const api = feathers()

const restClient = rest(apiHost)

api.configure(restClient.fetch(window.fetch.bind(window)))
api.configure(authentication())

export default api